// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34XAP","question":"styles_question__ShM8J","description":"styles_description__2um9U"};